import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, KeyRound } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { Reveal } from "../Reveal";

export const LookupForm = ({ initial = "", error }) => {
  const { t, rtl } = useLang();
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  const [code, setCode] = useState(initial);
  const navigate = useNavigate();
  return (
    <form className="lookup-form" onSubmit={(e) => { e.preventDefault(); navigate(`/my/${code.trim().toUpperCase()}`); }}>
      <div className="field"><KeyRound size={18} /><input value={code} onChange={(e) => setCode(e.target.value)} placeholder={t.lookup.placeholder} required data-testid="lookup-code-input" /></div>
      <button className="btn btn-gold" type="submit" data-testid="lookup-submit-button">{t.lookup.button}<Arrow size={16} /></button>
      {error && <div className="error-text" style={{ width: "100%" }} data-testid="lookup-error">{error}</div>}
    </form>
  );
};

export const LookupSection = () => {
  const { t } = useLang();
  return (
    <section className="section" id="my" data-testid="lookup-section">
      <div className="container">
        <Reveal className="lookup">
          <div><span className="kicker">{t.lookup.kicker}</span><h2>{t.lookup.title}</h2><p>{t.lookup.sub}</p></div>
          <LookupForm />
        </Reveal>
      </div>
    </section>
  );
};
